export default __webpack_public_path__ + "static/media/up_arrow.f269e9a2.svg";